import { IExcelValidationDetails } from "../interfaces";

// export const EVENT_LOGS_REQUEST_TIME_FORMAT = "";
export const EVENT_LOGS_REQUEST_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss";
export const TIME_FILTER_FORMAT = "YYYY-MM-DD HH:mm:ss";

export const ROWS_PER_PAGE = 20;

export const CONTACT_NUMBER_REGEX = /^[6-9]{1}\d{9}$/;
export const NUMBER_PLATE_REGEX =
	/^(.*↑.*|([A-Za-z]{2}[0-9]{1,2}[A-Za-z]{1,3}[0-9]{2,4})|([0-9]{2}(bh|BH|bH|Bh)[0-9]{4}[A-Za-z]{1,2})|([A-Za-z]{2}[0-9]{6})|([A-Za-z]{3}[0-9]{4}))/;

export const IP_V4_REGEX =
	/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

export const CITY_NAME_REGEX = /^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/;

export const NOT_ONLY_NUMBER_REGEX = /(?!^\d+$)^.+$/;

export const PINCODE_REGEX = /^[1-9]{1}[0-9]{2}[0-9]{3}$/;

export const RTSP_REGEX =
	/^(rtsp):\/\/(?:([^\s@/]+?)[@])?([^\s/:]+)(?:[:]([0-9]+))?(?:(\/[^\s?#]+)([?][^\s#]+)?)?([#]\S*)?/;

// export const RTSP_REGEX = /^(\/dev\/video[0-9]{1,2}|rtsp:\/\/.*)$/g;

export const PERSON_NAME_REGEX = /^[a-z0-9 ,.'\-()/]+$/i;
export const FLAT_NUMBER_REGEX = /^[a-zA-Z0-9 ,*\-/]+$/;

export const PASSWORD_REGEX = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@!_%&*])/;

export const URL_REGEX =
	/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

export const NOTIFICATION_AUTO_DISMISS_TIME = Number(process.env.REACT_APP_NOTIFICATION_AUTO_DISMISS_INTERVAL) ?? 5; // IN SECONDS

export const DASHBOARD_CHART_REFRESH_INTERVAL = Number(process.env.REACT_APP_DASHBOARD_CHART_REFRESH_INTERVAL) ?? 30; // IN SECONDS
export const DASHBOARD_EVENTS_REFRESH_INTERVAL = Number(process.env.REACT_APP_DASHBOARD_EVENTS_REFRESH_INTERVAL) ?? 5; // IN SECONDS

export const DEVICE_STATUS_REFRESH_INTERVAL = Number(process.env.REACT_APP_DEVICE_STATUS_REFRESH_INTERVAL) ?? 15; // IN SECONDS

export const FORCE_SYNC_STATUS_POLLING_INTERVAL = 10; // IN SECONDS

export enum VEHICLE_TYPE_E {
	FOUR_WHEELER = 0,
	TWO_WHEELER = 1
}

export const VEHICLE_TYPES_LIST = [
	{ id: 0, name: "Four Wheeler" },
	{ id: 1, name: "Two Wheeler" }
];

// USER MANAGEMENT
export const USER_ROLE_OPERATOR_ID = 0;
export const USER_ROLE_STAFF_ID = 1;
export const USER_ROLE_ADMIN_ID = 2;

export const USER_ROLE_TYPES_E: { [key: number]: string } = {
	[USER_ROLE_OPERATOR_ID]: "Operator",
	[USER_ROLE_STAFF_ID]: "Staff",
	[USER_ROLE_ADMIN_ID]: "Admin"
};

// CAMERA SETUP
export const CAMERA_SETUP_STEPS = [
	{
		id: 0,
		label: "Region of Interest"
	},
	{
		id: 1,
		label: "Define Direction Arrow"
	},
	{
		id: 2,
		label: "Crossing Lines"
	}
];

export const CANVAS_POLYGON_COORDINATE_RADIUS = 5;
export const CANVAS_STROKE_COLOR = "yellow";

export const BBOX_STROKE_COLOR = "#05ff05";
export const BBOX_STROKE_WIDTH = 1.25;

export const DEFAULT_NUMBER_OF_LINES = 5;

// BUILDING CONFIG
export enum BUILDING_TYPES_E {
	BUILDING = 0,
	CUSTOM_ENTRIES = 1
}

export const CUSTOM_ENTRY_BUILDING_NAME = "Common Area";

// OTS
export enum CONFIG_MODE_E {
	GATE_GUARD = 0,
	ANPR = 1,
	MY_GATE = 3,
	GATE_GUARD_ON_PREMISE = 4,
	GATE_GUARD_OFFLINE = 5
}

export enum BARRIER_CONFIG_E {
	SINGLE_ENTRY = 0,
	SINGLE_EXIT = 1,
	DOUBLE = 2
}

export const ANDROID_USER_USERNAME = "GateGuard-App-User";

// SITE CONFIG
export enum CAMERA_MODE_PROTOCOL_E {
	UDP = 0,
	TCP = 1
}

export const DEFAULT_VALIDATIONS: IExcelValidationDetails = {
	name: {
		type: "char",
		strip: true,
		remove_whitespace: false,
		regex: PERSON_NAME_REGEX,
		capitalize: false,
		title: true,
		lower: false,
		char_size: 160,
		allow_null: false
	},
	number_plate: {
		type: "char",
		strip: true,
		remove_whitespace: true,
		regex: NUMBER_PLATE_REGEX,
		capitalize: true,
		title: true,
		lower: false,
		char_size: 17,
		allow_null: false
	},
	flat_number: {
		type: "char/dropdown",
		strip: true,
		remove_whitespace: false,
		regex: FLAT_NUMBER_REGEX,
		capitalize: false,
		title: false,
		lower: false,
		char_size: 160,
		allow_null: false
	},
	start_date: {
		type: "date",
		strip: true,
		remove_whitespace: false,
		regex: null,
		capitalize: false,
		title: false,
		lower: false,
		char_size: null,
		allow_null: false
	},
	end_date: {
		type: "date",
		strip: true,
		remove_whitespace: false,
		regex: null,
		capitalize: false,
		title: false,
		lower: false,
		char_size: null,
		allow_null: false
	},
	vehicle_type: {
		type: "dropdown",
		strip: true,
		remove_whitespace: false,
		regex: null,
		capitalize: false,
		title: false,
		lower: false,
		char_size: null,
		allow_null: false
	},
	phone_number: {
		type: "char",
		strip: true,
		remove_whitespace: true,
		regex: CONTACT_NUMBER_REGEX,
		capitalize: false,
		title: false,
		lower: false,
		char_size: 14,
		allow_null: false
	},
	auth_type: {
		type: "char",
		strip: true,
		remove_whitespace: true,
		regex: null,
		capitalize: false,
		title: false,
		lower: true,
		char_size: 150,
		allow_null: false
	},
	comment: {
		type: "char",
		strip: false,
		remove_whitespace: false,
		regex: null,
		capitalize: false,
		title: false,
		lower: false,
		char_size: 1000,
		allow_null: false
	},
	is_custom_flat_number: {
		type: "bool",
		strip: false,
		remove_whitespace: false,
		regex: null,
		capitalize: false,
		title: false,
		lower: false,
		char_size: null,
		allow_null: false
	},
	is_valid: {
		type: "bool",
		strip: false,
		remove_whitespace: false,
		regex: null,
		capitalize: false,
		title: false,
		lower: false,
		char_size: null,
		allow_null: false
	}
};

export const SYSTEM_INFO_MISSING_ERROR_MESSAGE = "System Information not found!";

export const DEPLOYMENT_ERROR_MESSAGE = "Deployment pre-requisites not fulfilled";

export const RPI_DEVICE_NAME = "rpi";

export const CAMERA_STANDARD_RESOLUTION = {
	width: 1920,
	height: 1080
};

export const CAMERA_STANDARD_FPS_RANGE = {
	min: 20,
	max: 25
};
